import { render, staticRenderFns } from "./AlertsInfo.vue?vue&type=template&id=b6060558&scoped=true&"
import script from "./AlertsInfo.vue?vue&type=script&lang=js&"
export * from "./AlertsInfo.vue?vue&type=script&lang=js&"
import style0 from "./AlertsInfo.vue?vue&type=style&index=0&id=b6060558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6060558",
  null
  
)

export default component.exports